import $api from '@/handler/axios'
import Vue from 'vue'

export const SET_COURSES = 'SET_COURSES'
export const SET_CATEGORY_COURSES = 'SET_CATEGORY_COURSES '
export const SET_COURSE_DETAIL = 'SET_COURSE_DETAIL '
export const SET_COURSE_SUBSCRIBED = 'SET_COURSE_SUBSCRIBED '

const state = {
  courses: [],
  categorycourses: [],
  coursedetail: [],
  coursesubscribed: [],
}

const mutations = {
  [SET_COURSES] (state, value) {
    state.courses = value
  },
  [SET_CATEGORY_COURSES] (state, value) {
    state.categorycourses = value
  },
  [SET_COURSE_DETAIL] (state, value) {
    state.coursedetail = value
  },
  [SET_COURSE_SUBSCRIBED] (state, value) {
    state.coursesubscibed = value
  },
}

const actions = {
  getCourses (context) {
    return new Promise((resolve, reject) => {
      $api.get('course/course/').then(res => {
        context.commit(SET_COURSES, res);
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  getFeatureCourses (context, categoryId) {
    return new Promise((resolve, reject) => {
      $api.getWithPayload(`course/paginated/?page=1&page_size=5&is_featured=true`).then(res => {
        context.commit(SET_CATEGORY_COURSES, res);
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  getCategoryCourses (context, categoryId) {
    return new Promise((resolve, reject) => {
      $api.getWithPayload(`course/paginated/?category=${categoryId}`).then(res => {
        context.commit(SET_CATEGORY_COURSES, res);
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  getCourseDetail (context, courseId) {
    return new Promise((resolve, reject) => {
      $api.getWithPayload(`course/course/${courseId}`).then(res => {
        context.commit(SET_COURSE_DETAIL, res);
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  getCourseSubscibed (context, courseId) {
    return new Promise((resolve, reject) => {
      $api.getWithPayload(`course/course-subscribed/`).then(res => {
        context.commit(SET_COURSE_SUBSCRIBED, res);
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}

/*
|--------------------------------------------------------------------------
| Getters
|--------------------------------------------------------------------------
*/
const getters = {
    courses: state => state.courses,
    categorycourses: state => state.categorycourses,
    coursedetail: state => state.coursedetail,
    coursesubscibed: state => state.coursesubscibed,
}

/*
|--------------------------------------------------------------------------
| Export the module
|--------------------------------------------------------------------------
*/
export default {
  state,
  mutations,
  actions,
  getters
}
